export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YNpoilUs6yLUrwB0lw.e31b1042.woff2";